// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'

const handleLeave = () => (dispatch, getState) => {
  const projectId = getState().projectSummary.get('projectId')

  return dispatch(push(
    projectId !== null
      ? `/project-management/${projectId}`
      : '/database-management/path'
  ))
}

export default handleLeave
